import { RefObject, useEffect, useState } from 'react';

const OVERFLOW_THRESHOLD_PX = 1;

/** Показывает, что содержимое элемента не помещается по высоте и его прокручивают. */
const useIsScrollable = (ref: RefObject<HTMLElement | null>): boolean => {
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const update = () => setIsScrollable(element.scrollHeight - element.clientHeight > OVERFLOW_THRESHOLD_PX);

    update();

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(element);

    const mutationObserver = new MutationObserver(update);
    mutationObserver.observe(element, { childList: true, subtree: true, characterData: true });

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [ref]);

  return isScrollable;
};

export default useIsScrollable;
